import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '分析口径',
    type: 'AMAI_AC',
}